export const DAYS = [
  {
    label: 'Monday',
    key: 'monday',
    dayCapKey: 'monday',
    scheduleKey: 'Monday',
    row_css: 'monday_row',
    isWeekDay: true,
    sunToSatOrder: 1,
  },
  {
    label: 'Tuesday',
    key: 'tuesday',
    dayCapKey: 'tuesday',
    scheduleKey: 'Tuesday',
    row_css: 'tuesday_row',
    isWeekDay: true,
    sunToSatOrder: 2,
  },
  {
    label: 'Wednesday',
    key: 'wednesday',
    dayCapKey: 'wednesday',
    scheduleKey: 'Wednesday',
    row_css: 'wednesday_row',
    isWeekDay: true,
    sunToSatOrder: 3,
  },
  {
    label: 'Thursday',
    key: 'thursday',
    dayCapKey: 'thursday',
    scheduleKey: 'Thursday',
    row_css: 'thursday_row',
    isWeekDay: true,
    sunToSatOrder: 4,
  },
  {
    label: 'Friday',
    key: 'friday',
    dayCapKey: 'friday',
    scheduleKey: 'Friday',
    row_css: 'friday_row',
    isWeekDay: true,
    sunToSatOrder: 5,
  },
  {
    label: 'Saturday',
    key: 'saturday',
    dayCapKey: 'saturday',
    scheduleKey: 'Saturday',
    row_css: 'saturday_row',
    isWeekDay: false,
    sunToSatOrder: 6,
  },
  {
    label: 'Sunday',
    key: 'sunday',
    dayCapKey: 'sunday',
    scheduleKey: 'Sunday',
    row_css: 'sunday_row',
    isWeekDay: false,
    sunToSatOrder: 0,
  },
];

export const DAYS_INFO = DAYS.reduce((a, d) => {
  a[d.key] = d;
  return a;
}, {});

export const NUMBER_OF_WEEKDAYS = DAYS.filter((day) => day.isWeekDay).length;
